<template>
  <b-container>
    <Header
      v-if="listExist('featured_collections')"
      :items="list('featured_collections')"
      type="collection"
    >
      {{ $t('main.groupers.collections.text') }}
    </Header>
    <div class="title text-center mt-5">
      <h2 class="grouper-subtitle">{{ $t('main.groupers.collections.text6') }}</h2>
    </div>
    <div class="w-100">
      <Grid :group="collections" :type="getCollectionName" />

      <div
        v-if="!enough"
        v-infinite-scroll="getData"
        infinite-scroll-disabled="loadingNiche"
        class="d-flex w-100 justify-content-center align-items-center"
      >
        <Loading />
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Header from '@/components/Groupers/PageHeader';
import Grid from '@/components/Groupers/Grid';
import Loading from 'UI/Loading';
export default {
  nuxtI18n: {
    paths: {
      en: '/collections',
      de: '/sammlungen',
      es: '/colecciones',
      pt: '/colecoes'
    }
  },
  components: {
    Header,
    Grid,
    Loading
  },
  data() {
    return {
      enough: false,
      addItems: false
    };
  },
  async fetch({ store }) {
    await Promise.all([
      store.dispatch('collections/LOAD_COLLECTIONS'),
      store.dispatch('listings/GET_LIST', {
        name: 'featured_collections',
        type: 'collection'
      })
    ]);
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  },
  computed: {
    ...mapGetters('listings', ['list', 'listExist']),
    ...mapGetters('experience', ['getMerch']),
    ...mapGetters('collections', ['getCollectionName']),
    ...mapState('collections', [
      'collections',
      'loadingCollection',
      'collectionsTotalPages',
      'collectionsCurrentPage'
    ])
  },
  methods: {
    async getData() {
      if (this.collectionsCurrentPage < this.collectionsTotalPages && !this.loadingCollection) {
        this.addItems = true;
        await this.$store.dispatch('collections/LOAD_COLLECTIONS', {
          page: this.collectionsCurrentPage + 1
        });
        this.collectionsCurrentPage === this.collectionsTotalPages && (this.enough = true);
      } else if (this.collectionsCurrentPage === this.collectionsTotalPages) this.enough = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 1.8em;
}
.grouper-subtitle {
  width: 100%;
  min-height: 100%;
  height: auto;
  padding: 0;
  font-weight: 400;
  line-height: 1.5;
  font-size: 28.8px;
}
</style>
